import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { selectTileSettingsState } from "../../../../store/selectors/fieldsStateSelectors";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks";
import SwitchField from "../../../common/SwitchField";
import PeriodDropdown from "./PeriodDropdown";

const GeneralSettings = () => {
  const dispatch = useAppDispatch();
  const settingsAreaValues = useSelector(selectTileSettingsState);

  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1">General</Typography>
      <SwitchField
        label="Compare with Previous Period"
        disabled={true}
        checked={settingsAreaValues.compareWithPreviousPeriod}
        onChange={(compareWithPreviousPeriod) => {
          dispatch(
            fieldsStateActions.updateSettings({
              settings: {
                compareWithPreviousPeriod: compareWithPreviousPeriod,
              },
            })
          );
        }}
      />
      <PeriodDropdown
        periodType={settingsAreaValues.periodType}
        onChangePeriodType={(periodType) => {
          dispatch(fieldsStateActions.updateSettings({ settings: { periodType } }));
        }}
      />
      <SwitchField
        label="Show Growth"
        checked={settingsAreaValues.showGrowth}
        disabled={true}
        onChange={(showGrowth) => {
          dispatch(
            fieldsStateActions.updateSettings({
              settings: {
                showGrowth: showGrowth,
              },
            })
          );
        }}
      />
    </Stack>
  );
};

export default GeneralSettings;
